import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
import DescriptionIcon from '@mui/icons-material/Description'
import EmailIcon from '@mui/icons-material/Email'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import MoveToInboxIcon from '@mui/icons-material/MoveToInbox'
import NotificationsIcon from '@mui/icons-material/Notifications'
import RateReviewIcon from '@mui/icons-material/RateReview'
import { SvgIconProps } from '@mui/material'

export const notificationIcon = (type: string, props?: SvgIconProps) => {
  switch (type) {
    case 'new_inbound_email':
      return <EmailIcon color="primary" {...props} />
    case 'email_send_failed':
      return <ErrorOutlineIcon color="error" {...props} />
    case 'unassigned_email':
      return <MoveToInboxIcon color="warning" {...props} />
    case 'availability_request':
      return <CalendarMonthIcon color="primary" {...props} />
    case 'invoice_send_failed':
      return <DescriptionIcon color="error" {...props} />
    case 'new_customer_feedback':
      return <RateReviewIcon color="info" {...props} />
    default:
      return <NotificationsIcon color="action" {...props} />
  }
}
